






























































    import {PopRoute, AddRoute, ReplaceRoute, Ticket} from "../../types/store";
import {Vue, Component, Prop} from 'vue-property-decorator';
    import {Getter, Mutation, State} from "vuex-class";
import AdminPageInfo from './AdminPageInfo.vue';
import AdminCard from './AdminCard.vue';
import btn from './btn.vue';
import PackageCard from './PackageCard.vue';
import Axios from "axios";
    import alzuhudLink from "@/components/Functions/Functions";
    import {makeArabic} from "@/components/Functions/Functions";

@Component({
    components: {
        AdminPageInfo,
        AdminCard,
        btn,
        PackageCard
    }
})
export default class UserDashboard extends Vue {
    private panelTitle: string;
    @State adminUser: string;
    @State routes: string[];
    // @State username: string;
    @Getter token: string;
    @Mutation popRoute: PopRoute;
    @Mutation replaceRoute: ReplaceRoute;
    @Mutation setTicketId: Function;
    @State language: any;
    packages: any[] = [];
    headers: any[] = [];
    items: any = [];

    async mounted(): Promise<void> {
        this.replaceRoute(['Dashboard']);
        this.$parent.$emit('update route');
        this.headers = this.language === 'ar' ? [
            {
                text: 'الموضوع',
                align: 'right',
                value: 'subject',
            },
            {
                text: 'الحالة',
                align: 'right',
                value: 'status'
            },
            { text: 'التاريخ', value: 'date' },
            { text: 'OP', value: 'action', sortable: false },
        ]: [
            {
                text: 'Subject',
                align: 'left',
                value: 'subject',
            },
            {
                text: 'Status',
                align: 'left',
                value: 'status'
            },
            { text: 'Date', value: 'date' },
            { text: 'OP', value: 'action', sortable: false },
        ];
        try {
            let response = await Axios.get(`http://${alzuhudLink}:8080/api/users/tickets/all`, {
              params: {
                token: this.token
              }
            });
            let data = <Ticket[]>response.data.res.data;
            // this.items = data.filter(ticket => ticket.user_id.username === this.username).map(ticket => ({
            this.items = data.map(ticket => ({
            // this.items = data.filter(ticket => ticket.user_id.username === 'xhahn').map(ticket => ({
                subject: ticket.subject,
                status: ticket.status,
                date: new Date(ticket.created_at).toLocaleDateString('en-US', {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                }),
                id: ticket.id,
            }));

        } catch (e) {
            console.error(e);
        }

        try {
            const response = await Axios.get(`http://${alzuhudLink}:8080/api/packages/all`, {});

            this.packages = response.data.res.data.map((item: any) => ({
                name: item.name,
                rating: item.rate,
                date: item.start_date,
                packageCode: item.code,
                price: item.price,
            }))
        } catch (e) {
        }
    }

    makeArabic(str: string) {
        return makeArabic(str);
    }

    split(str: string): string {
        let strData = parseFloat(str);
        let data = strData.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
        return data.split('.')[0];
    }
    /**
     *
     */
    constructor() {
        super();
        this.panelTitle = 'Dashboard';
    }
    beforeDestroy(): void {
        this.popRoute();
        this.$parent.$emit('update route');
    }

    checkTicket(item: any) {
        // @ts-ignore
        this.setTicketId(item.id);
        this.$router.push('/user-admin/ticket');
    }
}
